import { Container } from '#app/components/ui'
import avatarImage1 from '#app/images/avatars/avatar-1.png'
import avatarImage2 from '#app/images/avatars/avatar-2.png'
import avatarImage3 from '#app/images/avatars/avatar-3.png'
import avatarImage4 from '#app/images/avatars/avatar-4.png'
import avatarImage5 from '#app/images/avatars/avatar-5.png'
import avatarImage6 from '#app/images/avatars/avatar-6.avif'

const testimonials = [
	[
		{
			content: `I've never seen an event planning tool as comprehensive and intuitive as this app. It's transformed how we collaborate and manage timelines, making every event a masterpiece. A must-have for any event professional!`,
			author: {
				name: 'Sarah Turner',
				role: 'Event Director at Stellar Events Management',
				image: avatarImage1,
			},
		},
		{
			content: `As a seasoned event planner, I'm truly impressed. This app's venue management and timeline features have streamlined our operations like never before. It's become an indispensable tool in ensuring our events exceed expectations.`,
			author: {
				name: 'Jennifer Rodriguez',
				role: 'Senior Event Coordinator at Elegance Affairs',
				image: avatarImage4,
			},
		},
	],
	[
		{
			content: `Juggling multiple corporate events is a challenge, but this app's 'Smart Calendar Mode' has been a game-changer. It optimizes schedules, allowing us to focus on strategic planning and creating impactful experiences`,
			author: {
				name: 'Alex Foster',
				role: 'Corporate Event Strategist at Nexus Conferences',
				image: avatarImage5,
			},
		},
		{
			content: `Our clients are blown away by the level of collaboration and transparency this app provides. From vendor coordination to client updates, it's become the secret ingredient behind our unforgettable events.`,
			author: {
				name: 'Olivia Martinez',
				role: 'Event Producer at Enchanted Gatherings',
				image: avatarImage2,
			},
		},
	],
	[
		{
			content: `Running a music festival means countless moving parts. With this app's venue management and real-time updates, I can confidently say we've raised the bar in event organization. It's a festival planner's dream come true.`,
			author: {
				name: 'Michael Reynolds',
				role: 'Music Festival Organizer at SoundWave Productions',
				image: avatarImage3,
			},
		},
		{
			content: `Managing weddings demands precision. This app's 'Timeline Clarity' feature ensures our team executes flawlessly, and our clients are wowed. It's an investment in turning dreams into reality.`,
			author: {
				name: 'Amy Hahn',
				role: 'Founder & CEO of DreamScape Weddings',
				image: avatarImage6,
			},
		},
	],
]
interface IconProps extends React.SVGProps<SVGSVGElement> {
	// Specify any additional props required for your icon component
}

function QuoteIcon(props: IconProps) {
	return (
		<svg aria-hidden="true" width={105} height={78} {...props}>
			<path d="M25.086 77.292c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622C1.054 58.534 0 53.411 0 47.686c0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C28.325 3.917 33.599 1.507 39.324 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Zm54.24 0c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622-2.11-4.52-3.164-9.643-3.164-15.368 0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C82.565 3.917 87.839 1.507 93.564 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Z" />
		</svg>
	)
}

export default function Testimonials() {
	return (
		<section
			id="testimonials"
			aria-label="What our customers are saying"
			className="bg-slate-50 py-20 sm:py-32"
		>
			<Container>
				<div className="mx-auto max-w-2xl md:text-center">
					<h2 className="font-display text-3xl tracking-tight text-slate-900 sm:text-4xl">
						Loved by event planners worldwide.
					</h2>
					<p className="mt-4 text-lg tracking-tight text-slate-700">
						Event planners adore our app because it transforms their vision into
						reality, simplifyies complexities, and orchestrates success with
						every meticulously planned detail.
					</p>
				</div>
				<ul className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 sm:gap-8 lg:mt-20 lg:max-w-none lg:grid-cols-3">
					{testimonials.map((column, columnIndex) => (
						<li key={columnIndex}>
							<ul className="flex flex-col gap-y-6 sm:gap-y-8">
								{column.map((testimonial, testimonialIndex) => (
									<li key={testimonialIndex}>
										<figure className="relative rounded-2xl bg-white p-6 shadow-xl shadow-slate-900/10">
											<QuoteIcon className="absolute left-6 top-6 fill-slate-100 text-3xl tracking-tight text-slate-900" />
											<blockquote className="relative">
												<p className="text-lg tracking-tight text-slate-900">
													{testimonial.content}
												</p>
											</blockquote>
											<figcaption className="relative mt-6 flex items-center justify-between border-t border-slate-100 pt-6">
												<div>
													<div className="font-display text-base text-slate-900">
														{testimonial.author.name}
													</div>
													<div className="mt-1 text-sm text-slate-500">
														{testimonial.author.role}
													</div>
												</div>
												<div className="overflow-hidden rounded-full bg-slate-50">
													<img
														className="h-14 w-14 object-cover"
														src={testimonial.author.image}
														alt=""
														width={56}
														height={56}
													/>
												</div>
											</figcaption>
										</figure>
									</li>
								))}
							</ul>
						</li>
					))}
				</ul>
			</Container>
		</section>
	)
}
